import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { supabase } from '../supabase/client';
import { setOtherUsersTests, loadOtherUsersTestsFromCache } from '../Redux/ovulationTestsSlice';
import { incrementOperation, decrementOperation } from '../Redux/loadingSlice';

const TAG = '[OtherUsersTestsLoader]';

/**
 * OtherUsersTestsLoader - Loads other users' tests when listenerUserIds initializes
 * 1. Load from localStorage cache first for each user
 * 2. Then fetch from Supabase for each user
 * 3. Store in Redux
 * Uses global loading indicator
 */
function OtherUsersTestsLoader() {
  const dispatch = useDispatch();
  const listenerUserIds = useSelector((s) => s.ovulationTests.listenerUserIds);
  const otherUsersTests = useSelector((s) => s.ovulationTests.otherUsersTests);

  useEffect(() => {
    if (listenerUserIds.length === 0) return;

    const loadOtherUsersTests = async () => {
      // Show global loading indicator
      dispatch(incrementOperation('otherUsersTestsLoad'));

      try {
        // Load from cache first for each user
        for (const userId of listenerUserIds) {
          dispatch(loadOtherUsersTestsFromCache({ userId }));
        }

        // Fetch from Supabase for each user
        for (const userId of listenerUserIds) {
          const { data, error } = await supabase
            .from('ovulation_tests')
            .select('*')
            .eq('user_id', userId)
            .order('taken_at', { ascending: false });

          if (!error && data) {
            dispatch(setOtherUsersTests({ userId, tests: data }));
          }
        }
      } catch (err) {
      } finally {
        // Hide global loading indicator
        dispatch(decrementOperation('otherUsersTestsLoad'));
      }
    };

    loadOtherUsersTests();
  }, [listenerUserIds, dispatch]);

  return null;
}

export default OtherUsersTestsLoader;
